import Navbar from "../../components/navbar/navbar.jsx";
import { dadosLogin } from "../../zustand/zuztand";
import { Link, useNavigate } from "react-router-dom";
import "../menuaniversariantes/menu-aniversariantes.css"
import { useEffect, useState } from "react";
import moment from 'moment';
import api from "../../services/api.js";

function MenuAniversariantes(props) {
    const navigate = useNavigate();
    const { ifLogado } = dadosLogin();
    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const [dadosCid, setDadosCid] = useState([]);
    const logoAlter = "https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/colaboradores%2Ffoto_aniver%2Fanivers.jpeg?alt=media&token=a7364618-6072-4411-9051-23d117248d4a"
    const [dadosFranqueados, setDadosFranqueados] = useState([]);
    const [dadosLengthFranqueados, setDadosLengthFranqueados] = useState([]);
    const [dadosColab, setDadosColab] = useState([]);
    const [dadosLengthColab, setDadosLengthColab] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const local = moment().locale('pt-br').format('LL'); //converte a data par pt-br
    const local_novo = local.slice(5); // separa o texto inicial ex 12 se setembro de 2024 ficando somente setembro...
    const mesAtuals = (local.split(" ")[2]); // converte 12 de setembro de 2024  em array e pega o indice 2 (mes extenço)
    const [cadastrosFranquia, setCadastrosFranquia] = useState([]);
    const ehMobile = larguraTela < 1100;    

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setLarguraTela(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    //listando aniver cidades
    useEffect(() => {
        var mes = new Date();
        var month = mes.getMonth();
        var mesAtual = month + 1;
        let novo_array = [];

        api.get("/franquia_busca")
            .then((resp) => {
                // console.log(resp.data)
                resp.data.map((item) => {
                    let dtaAniver = parseInt(item.data_aniver_cidade.substring(3, 5));

                    if (dtaAniver === mesAtual) {
                        novo_array.push({
                            nome: item.razao_franquia,
                            cid: item.cidade_franquia,
                            img: item.img_cidade,
                            data: item.data_aniver_cidade
                        })
                    }
                })
                // console.log(novo_array)
                setDadosCid(novo_array);
            })
            .catch((err) => {
                setDadosCid([]);
                alert("Erro ao carregar dados");
            });
    }, []);

    //listando franquias aniver
    useEffect(() => {

        var mes = new Date();
        var month = mes.getMonth();
        var mesAtual = month + 1;
        let novo_array = [];

        api.get("/franquia_aniver_listar")
            .then((resp) => {
                //console.log(resp.data)
                resp.data.map((item) => {
                    let dtaAniver = parseInt(item.data_inalg.substring(3, 5));

                    if (dtaAniver === mesAtual) {
                        novo_array.push({
                            id: item.id_franquia,
                            empresa: item.razao_franquia,
                            apelido: item.nome_franquia,
                            data: item.data_inalg,
                            localizacao: item.cidade_franquia,
                            logo: item.img_franquia,
                            uf: item.uf_franquia
                        })
                    }
                })
                // console.log(novo_array)
                setCadastrosFranquia(novo_array);
            })
            .catch((err) => {
                setCadastrosFranquia([]);
                alert("Erro ao carregar dados");
            });

    }, []);

    //listando franqueados aniver
    useEffect(() => {

        var Xmas95 = new Date();
        var month = Xmas95.getMonth();
        var mesAtual = month + 1;

        let novo_array = [];

        api.get("/franqueados_busca")
            .then((resp) => {
                // console.log(resp.data)
                resp.data.map((item) => {
                    let dtaAniver = parseInt(item.data_nasc_franqueado.substring(3, 5));

                    if (dtaAniver === mesAtual) {
                        novo_array.push({
                            id_franqueado: item.id_franqueado,
                            nome: item.nome_franqueado,
                            img: item.img_franqueado,
                            data: item.data_nasc_franqueado
                        })
                    }
                })
                // console.log(novo_array)
                setDadosFranqueados(novo_array);
                setDadosLengthFranqueados(novo_array.length)
            })
            .catch((err) => {
                setDadosFranqueados([]);
                alert("Erro ao carregar dados");
            });

    }, []);

    //listando colaboradores
    useEffect(() => {

        var mes = new Date();
        var month = mes.getMonth();
        var mesAtual = month + 1;

        let novo_array = [];

        api.get("/col_aniver_listar")
            .then((resp) => {
                //console.log(resp.data)
                resp.data.map((item) => {
                    let dtaAniver = parseInt(item.data_nasc_col.substring(3, 5));

                    if (dtaAniver === mesAtual) {
                        novo_array.push({
                            nome: item.nome_colaborador,
                            data: item.data_nasc_col,
                            img: item.foto_aniver
                        })
                    }
                })
                //console.log(novo_array)
                setDadosColab(novo_array);
                setDadosLengthColab(novo_array.length)
            })
            .catch((err) => {
                setDadosColab([]);
                alert("Erro ao carregar dados");
            });

    }, []);

    const AniverCardCol = ({ nome, data, img }) => {
        return (
            <div className="card aniver-card shadow-sm">
                <div className="card-img-container">
                    <img
                        src={img}
                        className="card-img-top aniver-img"
                        alt={`Foto de ${nome}`}
                        onError={(e) => {
                            e.target.src = '/assets/default-avatar.png'; // fallback image
                        }}
                    />
                </div>
                <div className="card-body d-flex flex-column">
                    <h6 className="card-title aniver-nome text-center">{nome}</h6>
                    <small className="text-center">{data}</small>
                </div>
            </div>
        );
    };

    const AniverCardFranqueados = ({ nome, data, img }) => {
        return (
            <div className="card aniver-card shadow-sm">
                <div className="card-img-container">
                    <img
                        src={img || logoAlter}
                        className="card-img-top-2 aniver-img-2"
                        alt={`Foto de ${nome}`}
                        onError={(e) => {
                            e.target.src = '/assets/default-avatar.png'; // fallback image
                        }}
                    />
                </div>
                <div className="card-body d-flex flex-column">
                    <h6 className="card-title aniver-nome text-center">{nome}</h6>
                    <small className="text-center">{data}</small>
                </div>
            </div>
        );
    };

    function CadastroCardFranquia({ empresa, apelido, data, logo, uf }) {
        return <>
            <div className="card h-100 shadow-sm">
                <div className="card-body d-flex flex-column align-items-center ">
                    <div className="logo-container mb-1 ">
                        <img src={logo || "/api/placeholder/150/150"} alt={`Logo de ${empresa}`} className="img-fluid rounded-circle" />
                    </div>
                    <small className="card-title text-center fw-bold m-0">{empresa}</small>
                    <div className="card-text text-center">
                        <p className="mb-1 text-muted">
                            <i className="bi bi-geo-alt me-1"></i>
                            {apelido}- {uf}
                        </p>
                        <p className="text-muted small">
                            <i className="bi bi-calendar me-1"></i>
                            {data}
                        </p>
                    </div>
                </div>
            </div>
        </>
    };

    const tabs = [
        {
            id: 0,
            label: 'Franquias',
            content: (
                <div>
                    <div className="table-responsive ">
                        <div className="tela-card-fran">
                            <div className="container mb-2">
                                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3 justify-content-center mb-5">
                                    {cadastrosFranquia.map((item) => (
                                        <div className="col" key={item.id}>
                                            <CadastroCardFranquia
                                                empresa={item.empresa}
                                                localizacao={item.localizacao}
                                                apelido={item.apelido}
                                                data={item.data}
                                                logo={item.logo}
                                                uf={item.uf}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="row mb-5">

                                </div>
                                <div className="row mb-5">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        },
        {
            id: 1,
            label: 'Franqueados',
            content: (
                <div className="aniver-cards-container ">
                    <div className="aniver-cards-wrapper ">
                        {dadosFranqueados.map((item) => {
                            return (
                                <AniverCardFranqueados
                                    key={item.id_franqueado}
                                    nome={item.nome}
                                    data={item.data}
                                    img={item.img}
                                />
                            );
                        })}
                    </div>
                </div>
            )
        },
        {
            id: 2,
            label: 'Colaboradores',
            content: (
                <div className="aniver-cards-container ">
                    <div className="aniver-cards-wrapper ">
                        {dadosColab.map((item) => {
                            return (
                                <AniverCardCol
                                    key={item.id_colab_fran}
                                    nome={item.nome}
                                    data={item.data}
                                    img={item.img}
                                />
                            );
                        })}
                    </div>
                </div>
            )
        },
        {
            id: 3,
            label: 'Cidades',
            content: (
                <div className="">
                    <div className="d-block container-body-cidades">
                        <div className="d-flex flex-row div-cards-cid-mob">
                            {
                                dadosCid.map((item) => {
                                    return <div key={item.id_franquias} className="d-flex">
                                        <div className="col-10">
                                            {item.img ?
                                                <img src={item.img} className=" img-card-cidades-mob ms-3" alt="..." /> : <img src="  https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/franquias%2Fimg_cidades%2Faniver_cidade.jpg?alt=media&token=bbae0f5a-715e-4c2f-9d6d-6ed01d31b4c1" className=" img-card-cidades-mob ms-3" alt="..." />
                                            }
                                            <div className="ms-3 mt-2 d-flex">
                                                <p className="text-dark">{item.cid} - {item.data}.</p>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>

                    </div>
                </div>
            )
        }
    ];

    const handleBack = () => {
        navigate("/dashboard");
    };

    function imprimir() {
        navigate("/aniversarios");
    };
    return <>
        {ehMobile && ifLogado !== "notLogad" ?
            <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 ">
                            <ul className="nav nav-tabs custom-tabs" role="tablist">
                                {tabs.map((tab) => (
                                    <li key={tab.id} className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link custom-tab ${activeTab === tab.id ? 'active' : ''}`}
                                            onClick={() => setActiveTab(tab.id)}
                                            type="button"
                                            role="tab"
                                        >
                                            {tab.label}
                                        </button>
                                    </li>
                                ))}
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link custom-tab back-tab"
                                        onClick={imprimir}
                                        type="button"
                                    >
                                        Imprimir
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link custom-tab back-tab"
                                        onClick={handleBack}
                                        type="button"
                                    >
                                        Voltar
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="custom-card-body">
                                <div className="tab-content">
                                    <div className="tab-pane fade show active" role="tabpanel">
                                        {tabs[activeTab].content}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <>
                {
                    ifLogado !== "notLogad" ? <>
                        <div className="d-flex container-fundo-menu-aniver">
                            <Navbar tela="aniversarios" />

                            <div className="row container-body-menu-aniver">
                                <img className="banner-aniversariantes" src="https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/banners%2Faniversariantes.png?alt=media&token=c4e1993b-e9a6-4b3e-98d5-994540f2ce4b" alt="banner-aniversariantes" />

                                <div className="conteudo fixed-bottom">
                                    <div className="d-flex ms-5 justify-content-center">

                                        <div className="col-2 mb-2">
                                        </div>
                                        <div className="col-2 mb-2">
                                            <Link to="/aniversario-franqueados" className="btn-orange-aniver" aria-current="page">Franqueados</Link>
                                        </div>
                                        <div className="col-2 mb-2 ms-1">
                                            <Link to="/aniversario-franquias" className="btn-orange-aniver" aria-current="page">Franquias</Link>

                                        </div>
                                        <div className="col-2 mb-2 ms-1">
                                            <Link to="/aniversario-colaboradores" className="btn-orange-aniver" aria-current="page">Colaboradores</Link>
                                        </div>
                                        <div className="col-2 mb-2 ms-1">
                                            <Link to="/aniversario-cidades" className="btn-orange-aniver" aria-current="page">Cidades</Link>
                                        </div>
                                        <div className="col-2 mb-2 ms-1">
                                            <Link to="/aniversarios" className="btn-orange-aniver" aria-current="page">Imprimir</Link>
                                        </div>
                                        <div className="col-2 mb-2">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div></> : navigate('/login')
                }
            </>
        }
    </>
}
export default MenuAniversariantes;